module.exports = __webpack_public_path__ + "img/headBg.fb792247.png";